import script from "./ProblemInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ProblemInput.vue?vue&type=script&setup=true&lang=js"

import "./ProblemInput.vue?vue&type=style&index=0&id=ece265f8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ece265f8"]])

export default __exports__